import { useTranslation } from 'react-i18next'
import { useUserStore } from '@/store'

const UNIVERSAL_LINK_DOMAIN = 'https://kemapp.io'

export function useGetMessageAndLinkToShareMyProfile() {
  const { t } = useTranslation()
  const userAuthenticated = useUserStore((state) => state.userAuthenticated)

  const linkShareMyProfile = `${UNIVERSAL_LINK_DOMAIN}/user-profile/${userAuthenticated?.user_id}`

  const message = `I'm on Kem! Click to view my profile. Claim free dollars: ${linkShareMyProfile}. Download Kem app "Own your money, spend anywhere"`

  return {
    message,
    linkShareMyProfile,
    userProfile: userAuthenticated,
  }
}

export function useGetMessageAndLinkToShareMyProfileWithReferralCode({
  referralCode,
}: {
  referralCode: string
}) {
  const link = `https://t.me/kemapp_bot/startapp`
  const message = `I am on Kem! Click on the link to start using it together! Use my referral code to claim free dollars: ${referralCode}. \n${link}`
  return {
    message,
    link,
  }
}
